<template>
  <div class="hero">
    <img class="hero__img" :src="heroSrc" alt="">
    <div class="hero__fade"></div>
    <img class="hero__logo" :src="logoSrc" alt="Battle League Gaming">
    <div class="hero__pill">
      <span class="hero__pill-label">{{ brandConfig.priceLabel }}</span>
    </div>
    <h1 class="hero__heading">{{ heading }}</h1>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: 'BrandHero',
  props: {
    heading: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState(['brandConfig']),
    assetBrand() {
      return this.brandConfig.assetBrand || this.brandConfig.brand;
    },
    heroSrc() {
      return require(`@/brand/${this.assetBrand}/assets/hero-image.webp`);
    },
    logoSrc() {
      return require(`@/brand/${this.assetBrand}/assets/logo-lockup.png`);
    }
  }
}
</script>

<style scoped>
.hero {
  position: relative;
  width: 100%;
  line-height: 0;
}

.hero__img {
  display: block;
  width: 100%;
  height: auto;
}

/* Bottom-to-black fade. Percentages so it tracks the image at any frame width:
   216.8/297.333 = 72.9% (alpha 0), 276.9/297.333 = 93.1% (alpha 1).
   Target is #000, not the page's #040404 — the fade lands 4/255 below page ground. */
.hero__fade {
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom,
              rgba(0, 0, 0, 0) 72.9%,
              #000000 93.1%);
  pointer-events: none;
}

.hero__logo {
  position: absolute;
  top: 30px;
  left: 30.5px;
  width: 69px;
  height: auto;
}

/* 116 x 30 at (237, 31); right edge 353 lines up with the content column. */
.hero__pill {
  position: absolute;
  top: 31px;
  right: 22px;
  width: 116px;
  height: 30px;
  border-radius: 5px;
  background-color: #B3F50D;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero__pill-label {
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 11.4px;
  line-height: 1;
  color: #000000;
  white-space: nowrap;
}

/* Sits over the black end of the fade, inside the hero box. */
.hero__heading {
  position: absolute;
  left: 0;
  right: 0;
  top: 281.6px;
  margin: 0;
  font-family: 'Clash Display', sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 1;
  text-align: center;
  color: #FFFFFF;
}
</style>
